import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import iconLeftArrow from "../../../assets/images/icon-left-arrow.png";
import DialogAlert from "../../../shared/DialogAlertModal/DialogAlert";
import { Button } from "react-bootstrap";
import {
  getOneCalibrage,
  prendreAcces,
  libererAcces,
} from "../../../redux/actions/calibrage";
import { Avatar } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import Alert from "../../../components/Alert/Alert";
import "./calibrageEnCours.css";
import EvaluationCard from "./evaluationCard";
import EvaluationReference from "./evaluationReference";
import iconcalendar from "../../../assets/images/icon-calend.svg";
import RingLoaderShared from "../../../shared/RingLoader/RingLoader";
//Rq : commented code : Confetti Lib
// import useWindowSize from "react-use/lib/useWindowSize";
// import Confetti from "react-confetti";

const CalibrageEnCours = (props) => {
  // const { width, height } = useWindowSize();
  const history = useHistory();
  const { datacalib, accescalib } = useSelector((state) => state.calibrage);
  let val = window.location.search;
  let calibId = val.substring(val.indexOf("=") + 1);
  const [selectedEval, setSelectedEval] = useState();
  const [iscalibrageTermine, setIsCalibrageTermine] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const [allowEvalReference, setAllowEvalReference] = useState(false);
  const [currentlySelectedEval, setCurrentlySelectedEval] = useState();
  const [displayInfoBar, setDisplayInfoBar] = useState({
    displayInfoBar: false,
    id: 0,
  });
  const [showmessage, setShowmessage] = useState(false);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loading, setLoading] = useState(true);

  // const [confetti, setConfetti] = useState(false);

  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
  }
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
     dispatch(getOneCalibrage(calibId))
     .then(
      dispatch(prendreAcces(calibId))
    ).finally(() => setLoading(false))
    },[]);

  // useEffect(() => {
  //   if (datacalib?.evaluations?.length > 1) {
  //     let concernedEval = datacalib?.evaluations?.filter(
  //       (data) => data?.eval?.isRef
  //     );
  //     if (Number(concernedEval[0]?.eval?.note) > 50) {
  //       setConfetti(true);
  //     } else {
  //       setConfetti(false);
  //     }
  //   }
  // }, [datacalib?.evaluations]);

  useEffect(() => {
    setIsCalibrageTermine(datacalib.status === "Termine");
    setIsEditable(!accescalib);
    setAllowEvalReference(datacalib?.evaluations?.length >= 2);
  }, [datacalib, accescalib]);

  const [detailEval, setDetailEval] = useState([]);

  const handleClose = (confirm) => {
    setOpen(false);
    if (confirm) {
      if (selectedEval === currentlySelectedEval) {
        setSelectedEval(null);
        setDetailEval([]);
      } else {
        setSelectedEval(currentlySelectedEval);
        setDetailEval(
          datacalib?.evaluations?.filter(
            (evaluation) => evaluation.eval.id === currentlySelectedEval
          )
        );
      }
    }
  };
  const handleShow = (id) => {
    setCurrentlySelectedEval(id);
    setOpen(true);
  };
  const [isSaving, setIsSaving] = useState(false);
  const childRef = useRef();
  const handleSubmit = (event) => {
    if (childRef.current) {
      childRef.current.handleSubmit();
    }
  };
  const { message, status } = useSelector((state) => state.message);
  const [display, setDisplay] = useState("none");
  const onDisplay = (display) => {
    setDisplay(display);
  };

  return (
    <>
      {/* {confetti && (
        <Confetti width={width} height={height} numberOfPieces={50} />
      )} */}
      <div>
        <div id="nouvelle-eval-right-side" className="align-divs-vertical">
          <div className="container-of-right-side">
            <div id="nouvelle-eval-bar">
              <div className="div-bar">
                <div
                  onClick={() => {
                    displayInfoBar.displayInfoBar = false;
                    setDisplayInfoBar({ ...displayInfoBar });
                    dispatch(libererAcces(calibId));
                    history.push("quality-monitoring?id=3");
                  }}
                  className="container-icon-arraw-left"
                >
                  <img
                    alt="go back"
                    src={iconLeftArrow}
                    width="20"
                    height="20"
                  />
                </div>
                <h5 className="add-eval-title" style={{ marginBottom: "0" }}>
                  {" "}
                  Calibrage en cours{" "}
                </h5>
                <span className="badge-style-qm" pill>
                  {datacalib?.id}
                </span>
              </div>
              <div className="div-bar-info-calib">
                <div className="grille-name">
                  <span> {datacalib?.grid?.name} </span>
                </div>
                <div className="grille-name">
                  <span> {datacalib?.interaction} </span>
                </div>
                <div className="agent-date-box">
                  <div className="d-flex gap-15 align-center p-0">
                    <Avatar
                      alt={datacalib?.agent?.firstName}
                      sx={{ bgcolor: "#5800E2", width: "40px", height: "40px" }}
                      variant="circle"
                      className="borderedImg"
                    >
                      {datacalib?.agent?.firstName?.charAt(0)?.toUpperCase()}
                      {datacalib?.agent?.lastName?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <div className="name-date">
                      <div className="name">
                        L'evalué : {datacalib?.agent?.firstName}{" "}
                        {datacalib?.agent?.lastName}
                      </div>
                      <div className="date">
                        <img
                          alt="calendar"
                          src={iconcalendar}
                          className="calendar-icon"
                        />
                        <span>
                          {datacalib?.DateLimite
                            ? format(new Date(datacalib.DateLimite))
                            : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {loading?  
              <>
              <RingLoaderShared/>
              </>
            : 
            <div className="container container-calibrage-encours">
              {datacalib?.evaluations
                ?.filter((evaluation) => !evaluation.eval.isRef)
                ?.map((evaluation, index) => (
                  <React.Fragment key={evaluation.eval.id}>
                    <div
                      className="detailCard"
                      onClick={() =>
                        allowEvalReference &&
                        isEditable &&
                        !iscalibrageTermine &&
                        handleShow(evaluation.eval.id)
                      }
                    >
                      <EvaluationCard
                        CriteriaGroup={evaluation.CriteriaGroup}
                        evaluation={evaluation.eval}
                        grille={datacalib?.grid}
                        isSelected={evaluation.eval.id === selectedEval}
                        key={evaluation.eval.id}
                      />
                    </div>
                    {index <
                      datacalib.evaluations.filter(
                        (evaluation) => !evaluation.eval.isRef
                      ).length -
                        1 && (
                      <div className="separator-container">
                        <div className="vl"></div>
                        <div className="circle-vs">
                          <span>VS</span>
                        </div>
                        <div className="vl"></div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              {allowEvalReference && (
                <>
                  <div className="separator-container">
                    <div className="vl"></div>
                    <div className="circle-rslt">
                      <span>=</span>
                    </div>
                    <div className="vl"></div>
                  </div>
                  <div>
                    <EvaluationReference
                      ref={childRef}
                      grille={datacalib?.grid}
                      participants={datacalib?.participants}
                      DetailSelectedEval={
                        iscalibrageTermine
                          ? datacalib?.evaluations?.filter(
                              (evaluation) => evaluation.eval.isRef
                            )
                          : detailEval
                      }
                      agent={datacalib?.agent?.id}
                      organisateur={datacalib?.CreatedBy}
                      idCalibrage={datacalib?.id}
                      setSelectedEval={setSelectedEval}
                      setIsSaving={setIsSaving}
                      setShowmessage={setShowmessage}
                      setDisplay={setDisplay}
                      isDisabled={iscalibrageTermine}
                    />
                  </div>
                </>
              )}
            </div>
            }
            <div className="container-buttons_eval">
              <Button
                variant="primary"
                className="buttons"
                style={{
                  backgroundColor: "white",
                  borderColor: "#5800e2",
                  color: "#5800e2",
                  float: "right",
                }}
                onClick={() => {
                  dispatch(libererAcces(calibId));
                  history.push("quality-monitoring?id=3");
                }}
              >
                Annuler
              </Button>
              {!iscalibrageTermine && (
                <Button
                  variant="primary"
                  className="buttons"
                  style={{
                    backgroundColor: "#5800e2",
                    borderColor: "#5800e2",
                    float: "right",
                  }}
                  onClick={handleSubmit}
                  disabled={isSaving || !isEditable || !allowEvalReference}
                >
                  {isSaving === true ? `Chargement ...` : `Terminer`}
                </Button>
              )}
            </div>
          </div>
        </div>
        {showmessage && (
          <Alert
            message={"Il existe un critère obligatoire n’a pas été évalué."}
            status={"dangereux"}
            style={{ position: "absolute", bottom: 100 }}
            display={display}
            onDisplay={onDisplay}
          />
        )}
        {message && (
          <Alert
            message={message}
            status={status === "error" ? "dangereux" : "success"}
            style={{ position: "absolute", bottom: 100 }}
            display={display}
            onDisplay={onDisplay}
          />
        )}
        <DialogAlert
          open={open}
          handleClose={handleClose}
          title={"Confirmation"}
          message={`Voulez-vous vraiment ${
            selectedEval ? "désélectionner" : "sélectionner"
          } cette évaluation ?`}
        />
      </div>
    </>
  );
};

export default CalibrageEnCours;
